/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

export const TooltipBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const TooltipText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_light?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const TooltipRow = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(4),
}));

export const TooltipRightColumn = styled(Box)(({theme}) => ({
  maxWidth: '190px',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const TooltipRowHeading = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',

  'svg path': {
    fill: theme.palette.semantic_light?.surface.onSurface,
  },
}));

export const TooltipChartBox = styled(Box)(() => ({
  borderRadius: '8px',
  overflow: 'hidden',
  width: '64px',
  height: '64px',
}));

export const IconBox = styled(Box)(() => ({
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
